const keepAliveStore = {
    state: {
        cachePageName: '', //缓存组件名称
    },
    mutations: {
        //重置缓存组件名称
        resetCachePageName(state, res) {
            state.cachePageName = res;
        },
        //添加缓存组件名称
        addCachePageName(state, res) {
            if (state.cachePageName === '') {
                state.cachePageName = res;
            } else {
                let arr = state.cachePageName.split(',');
                if (res && typeof res === 'string') {
                    let i = arr.indexOf(res);
                    if (i <= -1) {
                        state.cachePageName = state.cachePageName + ',' + res;
                    }
                }
            }
        },
        //删除缓存组件名称
        delCachePageName(state, res) {
            let arr = state.cachePageName.split(',');
            if (res && typeof res === 'string') {
                let i = arr.indexOf(res);
                if (i > -1) {
                    arr.splice(i, 1);
                    state.cachePageName = arr.join();
                }
            }
        }
    },
    actions: {
    }
}

export default keepAliveStore